/**
 * 问题列表，高级搜索查询结果不精确的原因
 */
export const QueryInaccurateReason = {
  /**
   * 问题列表，第一步预先查出全版本issue id用于带入子版本做第二步查询的时候，超过了返回结果限制，导致数据缺失。
   */
  ISSUE_LIST_STEP_1_QUERY_CROSS_VER_OVERFLOW: 'ISSUE_LIST_STEP_1_QUERY_CROSS_VER_OVERFLOW',

  /**
   * 问题列表，查询结果的所有问题下的版本总和超过了限制，部分issue将缺失版本信息。
   */
  ISSUE_LIST_TOO_MANY_TOTAL_VERSIONS: 'ISSUE_LIST_TOO_MANY_TOTAL_VERSIONS',

  /**
   * 查询上报列表，第一步预先查询满足crash extra数据（更多线程等字段），超过了返回结果限制，导致数据缺失
   */
  CRASH_LIST_QUERY_CRASH_EXTRA_LIST_OVERFLOW: 'CRASH_LIST_QUERY_CRASH_EXTRA_LIST_OVERFLOW'
};

export default QueryInaccurateReason;
